import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { getActivityList, deleteActivity, updateActivityStatus } from '@/services/marketing/activity';
import { parseTime } from "@/utils/util.js";
import dateRange from '@/components/newdaterange/index.vue';
export default {
  name: 'Activity',
  i18n: require('./i18n-activity'),
  components: {
    dateRange: dateRange
  },
  data: function data() {
    var _this = this;
    var validateActivitytime = function validateActivitytime(rule, value, callback) {
      if (value.activitystarttime == '') {
        callback(new Error(_this.$t('activity.selectactivitytime')));
      } else {
        callback();
      }
    };
    return {
      dateformat: 'YYYY-MM-DD HH',
      typeValue: {
        activityType: undefined
      },
      typeRules: {
        activityType: [{
          required: true,
          message: this.$t('activity.typeprop'),
          trigger: 'change'
        }]
      },
      typeVisible: false,
      defaultLangObj: JSON.parse(localStorage.defaultLangObj),
      AllStatus: [{
        key: 0,
        value: this.$t('activity.notonline')
      }, {
        key: 3,
        value: this.$t('activity.itisover')
      }, {
        key: 4,
        value: this.$t('activity.notstarted')
      }, {
        key: 5,
        value: this.$t('activity.attheevent')
      }],
      AllTypes: [{
        key: 1,
        value: this.$t('activity.doublepoints')
      }, {
        key: 2,
        value: this.$t('activity.unitdiscount')
      }, {
        key: 3,
        value: this.$t('activity.specialoffer')
      }, {
        key: 4,
        value: this.$t('activity.fullreduction')
      }, {
        key: 5,
        value: this.$t('activity.fulldiscount')
      }, {
        key: 6,
        value: this.$t('activity.fullpackage')
      }],
      rules: {
        activitytime: [{
          required: true,
          validator: validateActivitytime,
          trigger: 'change'
        }]
      },
      datavalue: {
        activitytime: {
          activitystarttime: '',
          activityendtime: ''
        }
      },
      activityList: [],
      isTableLoading: false,
      visible: false,
      //调整数量
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        page: 1,
        size: 20,
        activityInfo: '',
        activityStatus: undefined,
        //   activityType: undefined,
        startTime: '',
        endTime: ''
      },
      listQuery: {
        page: 1,
        size: 20,
        activityInfo: '',
        activityStatus: undefined,
        //   activityType: undefined,
        startTime: '',
        endTime: ''
      },
      columns: [
      //活动名称
      {
        dataIndex: 'activityName',
        key: 'activityName',
        slots: {
          title: 'activitytitle' //自定义标头
        },
        scopedSlots: {
          customRender: 'activityname' //自定义表格里面的内容
        },
        ellipsis: true,
        width: '25%'
      },
      //活动类型
      // {
      // 	title: this.$t('activity.type'),
      // 	dataIndex: 'activityType',
      // 	key: 'activityType',
      // 	width: '10%',
      // 	scopedSlots: {
      // 		customRender: 'typename', //自定义表格里面的内容
      // 	},
      // },
      //活动时间
      {
        title: this.$t('activity.time'),
        dataIndex: 'startTime',
        key: 'startTime',
        width: '30%',
        scopedSlots: {
          customRender: 'activitystarttime' //自定义表格里面的内容
        }
      },
      //状态
      {
        title: this.$t('publicuse.status'),
        dataIndex: 'activityStatus',
        key: 'activityStatus',
        width: '10%',
        scopedSlots: {
          customRender: 'activitystate' //自定义表格里面的内容
        }
      },
      //更新时间
      {
        title: this.$t('publicuse.updatetime'),
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        width: '15%'
      }, {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: '10%'
      }],
      listTotal: 0
    };
  },
  filters: {},
  watch: {},
  created: function created() {
    this.getList();
  },
  computed: {},
  methods: {
    addNewActivity: function addNewActivity() {
      // this.typeVisible = true
      // this.typeValue.activityType = undefined
      this.$router.push({
        path: '/marketing/activity/addActivity'
        // query: {
        // 	activityType: this.typeValue.activityType
        // }
      });
    },
    /* 取消选择类型 */resetType: function resetType() {
      this.typeValue.activityType = undefined;
      this.typeVisible = false;
    },
    sureType: function sureType() {
      var _this2 = this;
      this.$refs.dataTypeForm.validate(function (valid) {
        if (valid) {
          _this2.$router.push({
            path: '/marketing/activity/addActivity',
            query: {
              activityType: _this2.typeValue.activityType
            }
          });
          _this2.typeVisible = false;
        }
      });
    },
    /* table发生变化时候调用 */tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.listQuery.page = pagination.current;
      this.listQuery.size = pagination.pageSize;
      this.getList();
    },
    //点击查询按钮调的接口
    inquireList: function inquireList() {
      this.listQuery = _.cloneDeep(this.queryParam);
      this.getList();
    },
    getList: function getList() {
      var _this3 = this;
      this.isTableLoading = true;
      getActivityList(this.listQuery).then(function (response) {
        var dataObj = response.data.data;
        if (response.data.code == 200) {
          _this3.activityList = dataObj.list;
          _this3.listTotal = dataObj.total;
        }
        // console.log(response)
      }).finally(function () {
        _this3.isTableLoading = false;
      });
    },
    /* 日期变化调用 */changUpdateDate: function changUpdateDate(dateRange) {
      if (dateRange.startDateClone != undefined) {
        this.queryParam.startTime = parseTime(dateRange.startDateClone._d, "{y}-{m}-{d}");
      } else {
        this.queryParam.startTime = "";
      }
      if (dateRange.endDateClone != undefined) {
        this.queryParam.endTime = parseTime(dateRange.endDateClone._d, "{y}-{m}-{d}");
      } else {
        this.queryParam.endTime = "";
      }
    },
    /* 修改活动时间 */modalChangeDate: function modalChangeDate(dateRange) {
      if (dateRange.startDateClone != undefined) {
        this.datavalue.activitytime.activitystarttime = dateRange.startDateClone.format("YY-MM-DD");
      }
      if (dateRange.endDateClone != undefined) {
        this.datavalue.activitytime.activityendtime = dateRange.endDateClone.format("YY-MM-DD");
      }
    },
    /* 查看方法 */lookActivity: function lookActivity(record) {
      this.$router.push({
        path: "/marketing/activity/lookActivity",
        query: {
          id: record.id,
          look: 1
          // activityType: record.activityType
        }
      });
    },
    /* 编辑方法 */updataActivity: function updataActivity(record) {
      this.$router.push({
        path: "/marketing/activity/editActivity",
        query: {
          id: record.id
          // activityType: record.activityType
        }
      });
    },
    /* 搜索，选择日期方法 */changeregistrationtimeDate: function changeregistrationtimeDate() {},
    //点击删除的时候，不关闭
    handleMenuClick: function handleMenuClick(record) {
      record.deleteVisible = true;
    },
    adjustnumber: function adjustnumber() {
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {}
      });
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visible = false;
      this.resetdatavalue();
    },
    resetdatavalue: function resetdatavalue() {
      this.datavalue = {
        total: '',
        name: ''
      };
    },
    /* 删除确认 */deleteConfirm: function deleteConfirm(record) {
      var _this4 = this;
      deleteActivity(record.id).then(function (response) {
        if (response.data.code == 200) {
          _this4.$message.success(_this4.$t('public.deleteSuccessfully'));
          _this4.getList();
        }
        record.deleteVisible = false;
      });
    },
    deleteCancel: function deleteCancel(record) {
      // this.$message.error(this.$t('public.cancelSuccessfully'))
      record.deleteVisible = false;
    },
    //上线确认
    onlineConfirm: function onlineConfirm(record) {
      var _this5 = this;
      var onlineData = {
        activityId: record.id,
        activityStatus: 1
      };
      if (record.updateActivityStatus) return;
      record.updateActivityStatus = true;
      updateActivityStatus(onlineData).then(function (response) {
        if (response.data.code == 200) {
          _this5.$message.success(_this5.$t('public.goonlinesuccess'));
          _this5.getList();
        }
        record.deleteVisible = false;
      }).finally(function () {
        record.updateActivityStatus = false;
      });
    },
    onlineCancel: function onlineCancel(record) {
      // this.$message.error(this.$t('public.cancelSuccessfully'))
      record.deleteVisible = false;
    },
    //下线确认按钮
    confirm: function confirm(record) {
      var _this6 = this;
      var offlineData = {
        activityId: record.id,
        activityStatus: 3
      };
      if (record.updateActivityStatus) return;
      record.updateActivityStatus = true;
      updateActivityStatus(offlineData).then(function (response) {
        if (response.data.code == 200) {
          _this6.$message.success(_this6.$t('public.offlinesuccess'));
          _this6.getList();
        }
        record.deleteVisible = false;
      }).finally(function () {
        record.updateActivityStatus = false;
      });
    },
    cancel: function cancel(record) {
      // this.$message.error(this.$t('public.cancelSuccessfully'))
      record.deleteVisible = false;
    },
    handleTypeChange: function handleTypeChange(value) {
      this.queryParam.type = value;
    },
    toggleAdvanced: function toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    copyConfirm: function copyConfirm(record) {
      this.$router.push({
        path: '/marketing/activity/addActivity',
        query: {
          id: record.id
        }
      });
    }
  }
};